if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        //商品タイプで処理変える
        const itemType = this.dataset.item_type ? this.dataset.item_type : 'normal';
        if (itemType == 'lottery') {
          this.form.addEventListener('submit', this.onLotterySubmit.bind(this));
        } else {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
        this.cartNotification = document.querySelector('cart-notification');
        this.modalAlcohol = document.querySelector('.overlay-alcohol');
        this.modalAlcohol.querySelector('.yes-btn').addEventListener('click', this.onSubmitHandler.bind(this, true));
      }

      onSubmitHandler(evt, is_alchole = false) {
        if (!is_alchole) {
          evt.preventDefault();
        }
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains('loading')) return;

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);
        var proId = JSON.parse(document.getElementById('productId').innerHTML);
        var LimitJsonData = parseInt(JSON.parse(document.getElementById('LimitJsonData').innerHTML));
        const errP = document.createElement('p');
        errP.textContent = window.variantStrings.quantityError.replace('[limit_num]', LimitJsonData);
        errP.className = 'attention-message';
        errP.id = 'limitMsgId';
        var limitMsgId = document.getElementById('limitMsgId');
        var isSubmit = true;
        const formData = new FormData(this.form);
        var count = 0;
        const alcoholBody = document.querySelector('body');
        const overlayAlcohol = document.querySelector('.overlay-alcohol');

        // nameがcustomer_order_countのinputを取得
        const inputElement = document.querySelector('input[name="customer_order_count"]');
        if (inputElement) {
          const inputValue = inputElement.value;
          console.log(`Customer Order Count: ${inputValue}`);
        } else {
          console.log('Input element with name "customer_order_count" not found.');
        }

        // IDが'customer_order_count'の<span>要素を取得
        const customerOrderCountElement = document.getElementById('customer_order_count');
        const cartProductCountElement = document.getElementById('cart_product_count');
        const remainingOrdersElement = document.getElementById('remaining_orders');

        // 対応する数量セレクト要素を取得
        const quantityInput = document.querySelector('.quantity__input');
    
        if (!quantityInput) return;
    
        // 購入済み数量と制限数を取得
        const purchasedQuantity = parseInt(quantityInput.getAttribute('data-purchased-quantity')) || 0;
        const limit = parseInt(quantityInput.getAttribute('data-limit-num')) || Infinity;
    
        // 現在選択されている数量を取得
        const selectedQuantity = parseInt(quantityInput.value) || 0;
    
        // 合計購入数を計算
        const totalQuantity = purchasedQuantity + selectedQuantity;
    
    
        if (totalQuantity > limit) {
          isSubmit = false;
        } else {
          isSubmit = true;
        }

        fetch('/cart.js')
          .then((response) => response.json())
          .then((data) => {
            data['items'].forEach(function (item) {
              if (item.product_id == proId && !Number.isNaN(LimitJsonData)) {
                var inputValue = inputElement ? parseInt(inputElement.value) : 0;
                count = count + item.quantity + inputValue;
                if (count >= LimitJsonData) {
                  isSubmit = false;
                }
              }
            });

            var quantity = parseInt(formData.get('quantity'));
            if (quantity + count > LimitJsonData && !Number.isNaN(LimitJsonData)) {
              isSubmit = false;
            }

            if (isSubmit) {
              if (limitMsgId !== null) {
                limitMsgId.remove();
              }
              submitButton.setAttribute('aria-disabled', true);
              submitButton.classList.add('loading');
              this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

              const config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];

              formData.append(
                'sections',
                this.cartNotification.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
              config.body = formData;
              fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    this.handleErrorMessage(response.description);
                    return;
                  }

                  this.cartNotification.renderContents(response);
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  if (is_alchole) {
                    alcoholBody.classList.remove('fixed');
                    alcoholBody.style.top = 0;
                    var scrollPosition = window.scrollY;
                    window.scrollTo(0, scrollPosition);
                    overlayAlcohol.style.display = 'none';
                  }
                  submitButton.classList.remove('loading');
                  submitButton.removeAttribute('aria-disabled');
                  this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                });
            } else {
              if (limitMsgId == null) {
                this.form.prepend(errP);
              }
              if (is_alchole) {
                alcoholBody.classList.remove('fixed');
                alcoholBody.style.top = 0;
                var scrollPosition = window.scrollY;
                window.scrollTo(0, scrollPosition);
                overlayAlcohol.style.display = 'none';
              }
              return false;
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }

      onLotterySubmit(evt) {
        evt.preventDefault();

        // 選択された個数を取得
        const quantitySelect = document.querySelector('.quantity__input');
        const selectedQuantity = quantitySelect.value;

        if (document.getElementById('PopupModal-lotteryForm')) document.getElementById('PopupModal-lotteryForm').remove();

        const variantId = document.querySelector('input[name="id"]').value;
        const productVariantsJson = JSON.parse(document.getElementById('productVariantsJson').textContent);
        const currentVariant = productVariantsJson.find((variants) => {
          if (variants.id == variantId) return true;
        });
        if (currentVariant.featured_image.src) {
        }
        const variantHtml = `<h3 class="lang-shop-enable" data-translate-key="${currentVariant.name}- ${currentVariant.sku} - 個数：${selectedQuantity}">${currentVariant.name}- ${currentVariant.sku} - 個数：${selectedQuantity}</h3>
      <div class="lotttyImage"><img src="${currentVariant.featured_image.src.replace(/(.*)\./, '$1_medium.')}" alt=""></div>
      <input type="hidden" name="ProductName" value="${currentVariant.name}">
      <input type="hidden" name="SKU" value="${currentVariant.sku}">
      <input type="hidden" name="quantity" value="${selectedQuantity}">
      <input type="hidden" name="variantId" value="${currentVariant.id}">
      `;

        const lotteryFormTemplate = document.getElementById('lotteryForm');
        let clone = lotteryFormTemplate.content.cloneNode(true);
        clone.querySelector('.itemInfo').innerHTML = variantHtml;

        document.body.append(clone);
        const modalDialog = document.querySelector('#PopupModal-lotteryForm');

        window.Formrun._reset();
        window.Formrun.init('.formrun');

        modalDialog.show();
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
